/**
 * Product section wrapper.
 *
 * Routing:
 *   /product                              → Reports listing (if no query params)
 *   /product?table=...&events=...         → Standalone product builder (deep link)
 *   /product/new                          → New product report builder
 *   /product/reports/:id                  → Saved report builder (loaded from config)
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { ProductBuilder } from './ProductBuilder';

export function ProductPage() {
  return (
    <SectionPage
      basePath="/product"
      BuilderComponent={ProductBuilder}
      queryParamKeys={['table', 'events']}
    />
  );
}
